import styled from 'styled-components';

export const ModalContent = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	text-align: center;
	width: 100%;
`;

export const ModalTitle = styled.p`
	color: ${({ theme }) => theme.colors.principal.orion};
	font-size: 20px;
	font-weight: 500;
	line-height: 30px;
	margin: 0 0 8px;
`;

export const ModalDescription = styled.p`
	color: ${({ theme }) => theme.colors.principal.vanth};
	font-size: 16px;
	font-weight: 400;
	line-height: 22px;
	margin: 0 0 8px;
`;
export const ContainerButtons = styled.div`
	display: flex;
	flex-direction: row;
	gap: 16px;
	margin-top: 32px;
`;

interface ButtonProps {
	variant: 'pure' | 'abell';
}

export const Button = styled.button<ButtonProps>`
	background: ${({ theme, variant }) =>
		(variant === 'abell' && theme.colors.principal.abell) ||
		(variant === 'pure' && theme.colors.principal.pure)};
	border: ${({ theme, variant }) =>
		(variant === 'abell' && 'none') ||
		(variant === 'pure' && `1px solid ${theme.colors.principal.ceres}`)};
	border-radius: 8px;
	color: ${({ theme, variant }) =>
		(variant === 'abell' && theme.colors.principal.pure) ||
		(variant === 'pure' && theme.colors.principal.vanth)};
	cursor: pointer;
	padding: 9.5px 14px;
	width: 50%;

	&:disabled {
		cursor: default;
		opacity: 0.2;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 100%;
	}
`;
